export class ProductStatusObject {

    public static RESERVED_STATUS = new ProductStatusObject("RESERVED", "star", "created");
    public static EXPIRED_STATUS = new ProductStatusObject("EXPIRED", "star", "expired");
    public static CANCELLED_STATUS = new ProductStatusObject("CANCELLED", "skip_previous", "cancelled");
    public static ACTIVATED_STATUS = new ProductStatusObject("ACTIVATED", "done", "completed");
    public static TERMINATED_STATUS = new ProductStatusObject("ACTIVATED", "done", "terminated");
    public static UNKNOWN_STATUS = new ProductStatusObject("UNKNOWN", "warning", "");


    constructor(public state: string, public icon: string, public cssClass: string) {

    }

    static create(): ProductStatusObject {
        return null;
    }

    static createWithStatus(status: string): ProductStatusObject {
        return this.getProductStatus(status);
    }

    private static getProductStatus(status: string): ProductStatusObject {
        let productStatus: ProductStatusObject;
        switch (status) {
            case 'RESERVED':
                productStatus = this.RESERVED_STATUS;
                break;
            case 'EXPIRED':
                productStatus = this.EXPIRED_STATUS;
                break;
            case 'CANCELLED':
                productStatus = this.CANCELLED_STATUS;
                break;
            case 'ACTIVATED':
                productStatus = this.ACTIVATED_STATUS;
                break;
            case 'TERMINATED':
                productStatus = this.TERMINATED_STATUS;
                break;
            default:
                productStatus = this.UNKNOWN_STATUS;
                break;
        }
        return productStatus;
    }

    public equals(status: ProductStatusObject): boolean {
        return this.state === status.state;
    }

}
